import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-skeleton-item-usuario',
    templateUrl: './skeleton-item-usuario.component.html',
    styleUrls: ['./skeleton-item-usuario.component.scss']
})
export class SkeletonItemUsuarioComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

}
